<section class="banner">
    <div class="container-fluid bg mt-5">
        <div class="container mt-lg-5 mt-2 py-lg-5 ">
            <div class="d-flex flex-lg-row flex-column-reverse gap-lg-5 align-items-center">
                <div class=" col-lg-6 col-12 d-flex  text-lg-start align-items-center">
                    <div class="px-2 pt-3 pt-lg-0">
                        <h1 class="fw-bolder ">
                            <span class="font-56 d-none d-lg-block">
                                  <span class="brand-primary-text-color">UGMS</span>
                            All-in-One Solution To Manage University Groups Seamlessly
                            </span>
                            <span class="d-lg-none">
                                UGMS<span class="brand-primary-text-color"> UGMS</span>
                            All-in-One Solution To Manage University Groups Seamlessly
                            </span>
                        </h1>
                        <p class="my-lg-4 text-secondary f-20 justify-text">University Group Management System (UGMS)
                            is an educational ERP system that transforms your university’s academic and administrative
                            operations with ease of technology. The software helps to manage and control multiple
                            university groups under one roof, allowing seamless communication, and centralized
                            management for students, faculty, and administrators. Additionally, with features like
                            automated workflows, real-time updates, and secure data storage, UGMS fosters productivity
                            and enhances connectivity within universities. Experience the future of university group
                            management with UGMS – where efficiency meets innovation!
                        </p>
                        <button class="brand-primary-text-color py-2 bg-white border-0 shadow-lg px-5 rounded-0 fw-bold hover-effect"
                                (click)="openModal()">Take a Demo
                            <i
                                class="ms-3 fa-solid fa-arrow-right"></i>
                        </button>
                        <ng-template #contactFormModal>
                            <app-contact-form [isModalOpen]="isModalOpen"
                                              (closeModal)="closeModal()"></app-contact-form>
                        </ng-template>
                        <div *ngIf="isModalOpen" class="modal-overlay" (click)="handleOverlayClick($event)">
                            <ng-container *ngTemplateOutlet="contactFormModal"></ng-container>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-12 d-flex justify-content-end  border d-flex justify-content-center">
                    <div class="position-relative">
                        <img src="assets/img/landing-new/ugms/University Group Management System.webp"
                             class="img-fluid rounded-4" alt="College Management Systemr Image" id="video-thumbnail">
                        <button class="play-button position-absolute" (click)="playVideo()"></button>
                        <video #videoElement class="d-none rounded-4 w-100" controls>
                            <source src="assets/img/landing-new/ugms/University Group Management System_Volmint Technology (1).mp4" type="video/mp4">
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="container-fluid">
    <div class="container py-5">
        <div class="d-flex flex-lg-row flex-column-reverse gap-lg-5 align-items-center ">
            <div class="col-lg-6 py-lg-5">
                <h2 class=" fs-1 fw-bolder">Streamline Group Management with Our
                    <span class="brand-primary-text-color"> Powerful UGMS</span></h2>
                <p class="my-2 text-secondary text-wrap justify-text">The University Group Management Software
                    (UGMS) is a comprehensive software solution designed to simplify and streamline all aspects of group
                    management within universities. It combines robust functionality with an intuitive interface, making
                    it the perfect tool for organizing, coordinating, and effectively managing academic and
                    administrative tasks.
                </p>

                <div class="row g-3 py-2 py-lg-0">
                    <div class="col-12 col-md-6  fw-bold text-center "
                         *ngFor="let item of powerfullToUse">
                        <div class="brand-primary-bg text-white w-100 px-5 py-3 powerful-item">
                            {{ item.text }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 pb-3 pb-lg-0  text-right align-self-center ">
                <img src="assets/img/landing-new/ugms/Streamline Group Management with Our Powerful UGMS.webp" class="" alt="University Management Software">
            </div>
        </div>
        <div class="row py-5 align-items-center g-lg-5">
            <div class="col-lg-6 pb-3 pb-lg-0 ">
                <img src="assets/img/landing-new/ugms/Most Prominent Features of UGMS.webp" class="w-100" alt="University Management Software">
            </div>
            <div class="col-lg-6 py-lg-5">
                <h2 class=" fs-1 fw-bolder">
                    Most Prominent Features of UGMS</h2>
                <p class="my-lg-4 text-secondary text-wrap justify-text">UGMS is crafted to transform how universities
                    work with its unique features. This interconnected university management system centralizes
                    operations across multiple campuses and users, ensuring seamless data sharing and internal
                    collaboration. The system offers real-time data insights, empowering informed decision-making. With
                    the blend of user-centric design and functionality, the University Group Management System focused
                    on effortless management.

                </p>
                <div class="row g-3">
                    <div class="col-6 col-lg-6 col-lg-6 col-xxl-4 col-6 px-0 my-2 d-flex align-items-center"
                         *ngFor="let item of features">
                        <span>
                            <img src="{{item.icon}}" alt="University Management Software" class="img-fluid ">
                        </span>
                        <span class="ms-2 fs-sm-5  ">
                            <p class="text-secondary fw-bold">
                                {{ item.text }}
                            </p>

                        </span>
                    </div>
                </div>
            </div>

        </div>
        <div class="d-flex flex-lg-row flex-column-reverse gap-lg-5 align-items-center ">
            <div class="col-lg-6">
                <h2 class=" fs-1 fw-bolder">
                    <span class="brand-primary-text-color">UGMS Comprehensive Modules</span> for Seamless Management
                </h2>
                <p class=" text-secondary text-wrap justify-text">UGMS comes with versatile modules designed to
                    simplify university operations. Easily manage and update courses, programs, subjects, and branches
                    all in one place. These modules empower institutions to streamline academic management, ensuring
                    accuracy, efficiency, and effortless coordination across all departments.

                </p>
                <button class="btn text-white brand-primary-bg px-5 rounded-0 hover-white fw-bold"
                        (click)="goTo('/contact')">Book Appointment
                    <i
                        class="ms-3 fa-solid fa-arrow-right"></i>
                </button>
            </div>
            <div class="col-lg-6 ">
                <img src="assets/img/landing-new/ugms/UGMS Comprehensive Modules for Seamless Management.webp" class="mb-2 mb-lg-0" alt="University Management Software">
            </div>
        </div>
    </div>
</div>

<div class="container-fluid brand-primary-bg">
    <div class="container py-5">
        <h2 class="text-white text-lg-center mt-lg-5 fw-bold">What Makes Our University Group Management Software Stand
            Out?</h2>
        <p class="text-white text-lg-center text-wrap justify-text">Volmint Technologies is aware of the difficulties in
            navigating the dynamic realm of higher education. Our college and university administration software, like
            UGMS, is therefore designed to meet the demands of modern universities. Our robust higher education CRM
            guarantees your institution's success and expansion.

        </p>
        <div class="row gy-lg-5  py-lg-5">
            <div class="col-lg-4 col-md-6" *ngFor="let item of whyChoose; let i = index">
                <div class="d-flex  align-items-center ">
                    <div>
                        <div
                            class="h-w-40 text-center  rounded-circle bg-white fw-bold text-black d-flex align-items-center justify-content-center ">{{ i + 1 }}
                        </div>
                    </div>

                    <div class="px-2">
                        <h3 class="text-white my-4 fw-bold">{{ item.header }}</h3>

                    </div>
                </div>

                <p class="text-white justify-text">{{
                        item.text
                    }}</p>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid pt-5">
    <div class="container">
        <h2 class=" fs-1 fw-bolder text-center">
            <span class="brand-primary-text-color">Exclusive Benefits</span> for You</h2>
        <div class="row py-2 justify-content-between gy-4">
            <div class="col-lg-4">
                <div class="card h-100 border-0 shadow rounded-4 p-4 bg-white p-4">
                    <h4 class="fw-bold">Admission Management Module (AMM)</h4>
                    <p class="text-secondary text-wrap justify-text">The AMM module provides users with access to
                        oversee and manage the entire admission process including student consultation and enrollment.
                        Additionally, it allows the management of credit transfer, lateral entries, student
                        re-registration, multi university management system, social media lead integration, real-time
                        notifications, and reporting panels.
                    </p>
                </div>

            </div>
            <div class="col-lg-4">
                <div class="card h-100 border-0 shadow rounded-4 p-4 bg-white p-4">
                    <h4 class="fw-bold">Student Management Module (SMM)</h4>
                    <p class="text-secondary text-wrap justify-text"> The SMM module provides a comprehensive student
                        management system, including a learning management system for online and recorded lectures.
                        Additionally, chatbot integration, notification, reminders, audio-video sessions, personalized
                        support services, and detailed examination and documentation management for students can be
                        managed with it.
                    </p>
                </div>

            </div>
            <div class="col-lg-4">
                <div class="card h-100 border-0 shadow rounded-4 p-4 bg-white p-4">
                    <h4 class="fw-bold">Management Administrative Module (MAM)</h4>
                    <p class="text-secondary text-wrap justify-text"> The MAM is a comprehensive module that helps to
                        manage and oversee admission centers, sessions, student lead inquiries, enrollment ID
                        generation, accounting, reporting, Learning Management System, EMS, EMS, online/offline
                        examinations, email notifications, question paper upload, DMS, and support services.
                    </p>
                </div>
            </div>
        </div>
        <div class="d-flex flex-lg-row flex-column-reverse gap-lg-5 align-items-center py-lg-4">
            <div class="col-lg-7 py-3 py-lg-5">
                <h2 class=" fs-1 fw-bolder">
                    <span class="brand-primary-text-color">Free Enhancements </span> from Volmint to Optimize Your UGMS
                    Experience
                </h2>
                <p class=" text-secondary text-wrap justify-text">To empower the future through technology, Volmint
                    Technology is striving to simplify the educational system while facilitating innovation. In keeping
                    with our goal and vision, we are offering our clients and consumers free services that improve
                    productivity and user experience.

                </p>
                <div class="row  ">
                    <div class="col-sm-6 col-12 px-0 px" *ngFor="let item of offerings">
                        <div class="offer-item d-flex align-items-center p-2 rounded shadow-lg mx-auto">
      <span class="offer-icon">
        <img src="assets/img/project/check.png" alt="University Management Software" class="img-fluid">
      </span>
                            <p class="ms-4 fw-bold text-secondary">
                                {{ item.text }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 pt-5 align-self-center
             d-flex justify-content-end">
                <img src="assets/img/landing-new/ugms/Free Enhancements from Volmint to Optimize Your UGMS Experience.webp" class=" " alt="University Management Software"></div>
        </div>
    </div>
</div>

<div class="container-fluid mt-lg-4 pb-lg-5">
    <div class="container">
        <div class="row">
            <div class="col-12  col-lg-5">
                <div class="">
                    <img src="assets/img/landing-new/contact-us/faq.png" alt="Admission Management System"
                         class="img-fluid d-none d-lg-block"/>
                    <h2 class="fw-bold text-center mt-4 mt-lg-0 fs-2 text-lg-start text-secondary">Frequently Asked Questions</h2>
                    <p class="text-secondary d-none d-lg-block">Have a question that is not answered? You can contact us at</p>
                    <p class="brand-primary-text-color d-none d-lg-block fw-bold">Email: <a href="mailto:support@volmint.com"
                                                                                            class="text-decoration-underline brand-primary-text-color">support@volmint.com</a>
                    </p>
                    <button type="submit"
                            class="d-none d-lg-block brand-primary-bg border-0 color-white px-5 py-2 fs-6 mt-4 fw-bold hover-effect"
                            (click)="goTo('/faq')">
                        View All Faqs
                    </button>
                </div>
            </div>
            <div class="col-12 col-lg-7 mt-4">
                <div class="accordion" id="faqAccordion">
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingOne">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                <span class="fs-6 fw-bold" style="color: #5236FF;">  <div class="encircled-icon me-1">
        <i class="fas fa-question fw-bold"></i>
    </div> &nbsp;What is Volmint’s UGMS?</span>
                            </button>
                        </h3>
                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body text-secondary justify-text">
                                University Group Management Software is a brainchild of Volmint Technologies, a renowned
                                IT company in India. The UGMS automates the university operations with ease of
                                technology. It helps to manage and control university all departments and workflow.
                                Moreover, it allows to management of multi-university with a single platform.

                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingTwo">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <span
                            class="fs-6 fw-bold" style="color: #5236FF;"><div class="encircled-icon me-2">
        <i class="fas fa-question fw-bold"></i>
    </div>  Does UGMS provide data security?</span>
                            </button>
                        </h3>
                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body text-secondary justify-text">
                                Absolutely, we have used the latest robust tools and techniques to safeguard
                                institutional sensitive data to avoid any mis happening or unethical practices. We have
                                provided role-based access to prevent data misleading.

                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingThree">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                <span class="fs-6 fw-bold" style="color: #5236FF;"><div class="encircled-icon me-2">
        <i class="fas fa-question fw-bold"></i>
    </div> Is there any customizable option available?</span>
                            </button>
                        </h3>
                        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body text-secondary justify-text">
                                Yes, we craft products as per your unique business needs and requirements. We will
                                understand your business goals and the issues you are facing while managing tasks with
                                your ongoing system and provide the best solution accordingly.

                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingFour">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                <span class="fs-6 fw-bold" style="color: #5236FF;"><div class="encircled-icon me-2">
        <i class="fas fa-question fw-bold"></i>
    </div>  Why choose Volmint’s UGMS?</span>
                            </button>
                        </h3>
                        <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body  text-secondary justify-text">
                                Being one of the foremost IT giants in India, we have provided the best customer support
                                and the most suitable solution as per your educational institute. Additionally, we are
                                offering several benefits at no extra cost such as lifetime maintenance, personalized
                                assistance, training sessions, extra modules, third-party tool integration, and social
                                media leads management.

                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingFive">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                <span class="fs-6 fw-bold" style="color: #5236FF;"><div class="encircled-icon me-1">
        <i class="fas fa-question fw-bold"></i>
    </div> &nbsp; How does UGMS differ from UMS and what is the cost of UGMS?</span>
                            </button>
                        </h3>
                        <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body  text-secondary justify-text">
                                UGMS or university group management system, allows the management of multiple
                                universities with a single platform. On the other hand, UMS, or a university management
                                system, works for a single university. To know more about the product or charges, get in
                                touch with us via Phone: +91 9310828501 or Email: <a href="mailto:support@volmint.com" target="_blank" class="d-inline"> support@volmint.com</a>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid mt-5 ums-bottom-bg ps-lg-5">
    <div class="container">
        <div class="row align-items-center py-5">
            <div class="col-lg-6 col-12 fs-2 color-white fw-bold mb-3 mb-lg-0 d-none d-lg-block">
                Ready to elevate your university management to next level?
            </div>
            <div class="col-lg-6 col-12 text-center">
                <span class="fs-4 fw-bold mb text-white">Fill out the form, and we’ll be in touch soon!
                </span>
                <div class="bg-light-pink shadow py-5 mt-2 px-4">
                    <form [formGroup]="contactForm" class="">
                        <div class="mb-4 d-sm-flex g-3 mx">
                            <input type="name" class="form-control bg-white rounded-3 text-secondary me-sm-1 py-3"
                                   id="name"
                                   formControlName="name"
                                   placeholder="Enter Your Name" required>
                            <small *ngIf="submitted && contactForm.get('name').hasError('required')"
                                   class="text-danger">
                                Field is required.
                            </small>
                            <input type="email" class="form-control mt-3 mt-md-0 bg-white rounded-3 text-secondary py-3"
                                   id="email" formControlName="email"
                                   placeholder="Enter Your Email" required>
                            <small *ngIf="submitted && contactForm.get('email').hasError('required')"
                                   class="text-danger">
                                Field is required.
                            </small>
                        </div>
                        <div class="mb-4">

                        </div>
                        <div class="mb-4">
                            <input type="tel" class="form-control bg-white rounded-3 text-secondary py-3"
                                   id="contact" formControlName="contact"
                                   placeholder="Enter Your Phone No." required>
                            <small *ngIf="submitted && contactForm.get('contact').hasError('required')"
                                   class="text-danger">
                                Field is required.
                            </small>
                        </div>
                        <div class="mb-4">
                                <textarea class="form-control rounded-3 bg-white text-secondary" id="message"
                                          formControlName="message"
                                          rows="4" style="resize: none;"
                                          placeholder="Your Message" required></textarea>
                            <small *ngIf="submitted && contactForm.get('message').hasError('required')"
                                   class="text-danger">
                                Field is required.
                            </small>
                        </div>
                        <div class="text-center mt-4">
                            <button type="submit"
                                    class="bg-color-blue border-0  color-white px-5 py-2 w-50 fs-6 fw-bold hover-effect"
                                    (click)="submit()">
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
